import type { DefaultMessageKey } from "../shared-types";

import { addMessage, getLastMessage } from "../state";
import { getDefaultMessage } from "./getDefaultMessage";

export const addFirstOpenMessageIfNeeded = (
    sessionId: string,
    expertName: string,
    messageKeyOverride?: DefaultMessageKey,
) => {
    const lastMessage = getLastMessage(sessionId);
    if (!lastMessage) {
        const firstOpenMessage = getDefaultMessage(messageKeyOverride ?? "firstOpen");
        addMessage(sessionId, {
            ...firstOpenMessage,
            text: firstOpenMessage.text.replace("$EXPERT_NAME", expertName),
            id: `firstOpen_${crypto.randomUUID()}`,
        });
    }
};
